import React, { useRef, useEffect } from 'react';
import Map from './Map';
import { createPopper } from '@popperjs/core';
import './Container.scss';
import Tooltip from './Tooltip';
import MapMobile from './MapMobile';
import StateMap from './StateMap';

function Container({
  handleClickNavButtons,
  currentArea,
  setCurrentArea,
  currentData,
  colorCode,
  handleClickMetroArea,
  northAm,
  zoomed,
  filler,
  currentClickedArea,
  currentState,
  currentStateName,
  stateLines,
  mapContainer,
  stateMap,
  buttonActive,
  handleClickIntroState
}) {
  const g = useRef();
  const tooltip = useRef();

  const createToolTip = (e) => {
    const content = tooltip.current;
    createPopper(e.target, content, {
      placement: 'bottom'
    });
    content.style.visibility = 'visible';
  };

  const handleMouseEnterMetroArea = (e) => {
    createToolTip(e);

    const fips = e.target.className.baseVal.slice(5, 10);
    setCurrentArea(currentData[fips]);
  };

  const handleMouseLeaveMetroArea = (e) => {
    tooltip.current.style.visibility = 'hidden';
  };

  useEffect(() => {
    if (buttonActive !== 'intro' || currentState) {
      stateMap.current.style.opacity = '0';
      stateMap.current.style.animation = '';
      stateMap.current.style.zIndex = '-1';
    } else {
      northAm.current.style.opacity = '0';
      northAm.current.style.animation = '';
    }
  }, [buttonActive, northAm, stateMap, currentState]);

  return (
    <div className="container minHeight" ref={mapContainer}>
      <div className="map" id="map">
        <Tooltip currentArea={currentArea} tooltip={tooltip} colorCode={colorCode} />

        <div className="map__filler desktop-only" ref={filler} />
        {currentState ? (
          <MapMobile
            currentStateName={currentStateName}
            handleClickNavButtons={handleClickNavButtons}
            buttonActive={buttonActive}
          />
        ) : (
          <Map
            handleClickMetroArea={handleClickMetroArea}
            handleMouseEnterMetroArea={handleMouseEnterMetroArea}
            handleMouseLeaveMetroArea={handleMouseLeaveMetroArea}
            g={g}
            colorCode={colorCode}
            zoomed={zoomed}
            northAm={northAm}
            currentClickedArea={currentClickedArea}
            stateLines={stateLines}
          />
        )}

        <StateMap handleClickIntroState={handleClickIntroState} stateMap={stateMap} />
      </div>
    </div>
  );
}

export default Container;
